import * as Yup from 'yup';

export const validationSchemaTeamReport = Yup.object({
  unit: Yup.object()
    .shape({
      label: Yup.string(),
      value: Yup.string(),
    })
    .nullable(),
  cargo: Yup.object()
    .shape({
      label: Yup.string(),
      value: Yup.string(),
    })
    .nullable(),
  entity: Yup.object()
    .shape({
      label: Yup.string(),
      value: Yup.string(),
    })
    .nullable(),
  groups: Yup.array().of(
    Yup.object()
      .shape({
        label: Yup.string(),
        value: Yup.string(),
      })
      .nullable(),
  ),
  course: Yup.object()
    .shape({
      label: Yup.string(),
      value: Yup.string(),
    })
    .nullable(),
  position: Yup.object()
    .shape({
      label: Yup.string().required('Campo é Obrigatório.'),
      value: Yup.string().required('Campo é Obrigatório.'),
    })
    .required('Campo é Obrigatório.'),
  semester: Yup.object()
    .shape({
      label: Yup.string().nullable(),
      value: Yup.string().nullable(),
    })
    .nullable(),
});

export const initialValuesTeamReport = {
  unit: null,
  entity: null,
  groups: [],
  course: null,
  position: null,
  semester: null,
};
